/**
 * Экранирует специальные символы для строки, из которой создается регулярное выражение.
 * @param {string} string -
 * @returns {string} -
 * @see https://github.com/sindresorhus/escape-string-regexp
 */
export default function escapeStringRegexp(string = '') {
  return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d')
}
